import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { BookOpen } from 'lucide-react';

export default function Rules() {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/rules')
      .then(res => setRules(res.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4 animate-fade-in" data-testid="rules-page">
      <div className="flex items-center gap-3 mb-6">
        <BookOpen size={32} className="text-[#F4E39E]" />
        <h2 className="text-2xl lg:text-3xl font-extrabold gold-text" style={{ fontFamily: 'Montserrat' }}>
          Reglas del Juego
        </h2>
      </div>

      <p className="text-white/60 text-sm lg:text-base mb-6">
        Conoce cómo funciona el sistema de puntajes y las reglas de la quiniela.
      </p>

      {loading ? (
        <div className="text-center text-white/50 py-10">Cargando reglas...</div>
      ) : rules.length === 0 ? (
        <div className="glass-card p-8 text-center text-white/40">
          No hay reglas disponibles
        </div>
      ) : (
        <div className="space-y-4">
          {rules.map((rule, index) => (
            <div key={rule.id} className="glass-card p-6" data-testid={`rule-${index}`}>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#F4E39E]/10 border border-[#F4E39E]/30 flex items-center justify-center">
                  <span className="text-[#F4E39E] font-bold text-lg" style={{ fontFamily: 'Montserrat' }}>
                    {index + 1}
                  </span>
                </div>
                <div className="flex-1">
                  <h3 className="text-white font-bold text-lg mb-2" style={{ fontFamily: 'Montserrat' }}>
                    {rule.title}
                  </h3>
                  <p className="text-white/70 text-sm lg:text-base leading-relaxed whitespace-pre-wrap">
                    {rule.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="glass-card p-6 mt-8 border-l-4 border-[#F4E39E]">
        <h3 className="text-[#F4E39E] font-bold text-lg mb-3" style={{ fontFamily: 'Montserrat' }}>
          Sistema de Puntuación
        </h3>
        <div className="space-y-2 text-white/70 text-sm lg:text-base">
          <div className="flex items-center gap-3">
            <span className="text-[#F4E39E] font-bold text-2xl">3</span>
            <span>puntos por acertar el <strong className="text-white">marcador exacto</strong></span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-[#F4E39E] font-bold text-2xl">1</span>
            <span>punto por acertar el <strong className="text-white">resultado</strong> (ganador o empate)</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-red-400 font-bold text-2xl">0</span>
            <span>puntos si no aciertas el resultado</span>
          </div>
        </div>
      </div>
    </div>
  );
}
